export const ALL = 'ALL';
export const POPULAR = 'POPULAR';
export const LIVE = 'LIVE';
export const FINISHED = 'FINISHED';
export const ODDS = 'ODDS';
export const UPCOMING = 'UPCOMING';

export const statusFilters = [ALL, POPULAR, UPCOMING, LIVE, FINISHED, ODDS];
